import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { computed } from 'mobx';
import { Collection } from 'core/model/Collection';
import generateLayout, { newPanelLayout } from 'app/stores/boards/generateLayout';
import BoardPanelModel from './BoardPanelModel';
let BoardPanelCollection = (_class = class BoardPanelCollection extends Collection {
  constructor(data = [], {
    parent
  }) {
    super(data);
    this.parent = void 0;
    this.forge = (attributes, options = {}) => {
      const layouts = 'parent_panel_id' in attributes && attributes.parent_panel_id ? this.get(Number(attributes.parent_panel_id))?.layout || generateLayout([]) : this.parent.layout;

      // initialize panel layout
      attributes.layout = newPanelLayout(layouts, 'toJS' in attributes ? attributes.toJS() : attributes || {});
      return this.build(attributes, options);
    };
    this.parent = parent;
  }
  get url() {
    return `/api/ui/boards/${this.parent.id}/panel`;
  }
  get model() {
    return BoardPanelModel;
  }
  hasPanelOfType(type) {
    return this.models.some(m => m.get('type') === type);
  }
  get hasUdePanel() {
    return this.hasPanelOfType('ude');
  }
  get topLevelPanels() {
    return this.models.filter(m => !m.get('parent_panel_id'));
  }
  getSubPanels(parentPanelId) {
    return this.models.filter(m => `${m.get('parent_panel_id')}` === `${parentPanelId}`);
  }
}, _applyDecoratedDescriptor(_class.prototype, "hasUdePanel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUdePanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "topLevelPanels", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "topLevelPanels"), _class.prototype), _class);
export default BoardPanelCollection;